import { ebpCaseEmails } from '@packages/core-shared';
import { AlertError, Button, Modal } from '@percihealth/react';
import { useMemo, useState } from 'react';
import { EmailsApiRepository } from '../../../../../api';
import { useFirebase } from '../../../../../context';

interface Props {
  caseId: string;
  documentId: string | null;
  onClose: () => void;
}

export const DocumentToLandgModal = ({
  caseId,
  documentId,
  onClose,
}: Props) => {
  const { auth } = useFirebase();

  const emailsApiRepository = useMemo(
    () => new EmailsApiRepository(auth),
    [auth],
  );

  const [isSending, setIsSending] = useState(false);

  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const sendEmail = async () => {
    if (!documentId) {
      return;
    }

    try {
      setIsSending(true);
      setErrorMessage(null);
      await emailsApiRepository.resend({
        caseId,
        documentId,
        template: ebpCaseEmails.ToLandgCaseManagerDocument.id,
      });
    } catch (err) {
      console.error(err);
      setErrorMessage(err instanceof Error ? err.message : JSON.stringify(err));
    } finally {
      setIsSending(false);
    }
  };

  return (
    <Modal open={!!documentId} onClose={onClose} center>
      <h3>L&G - email sending confirmation</h3>
      <p>
        You are going to send the document to the L&G case manager.
        <br />
        Proceed?
        <br />
        <br />
      </p>
      {errorMessage && <AlertError>{errorMessage}</AlertError>}
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Button onClick={onClose} disabled={isSending}>
          Cancel
        </Button>

        <Button
          level="secondary"
          submitting={isSending}
          onClick={async () => {
            await sendEmail();
            onClose();
          }}
        >
          Send
        </Button>
      </div>
    </Modal>
  );
};
